import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { fetchAboutPage, fetchLandingPage } from "@/lib/sanity";
import { DEFAULT_ABOUT_PAGE, DEFAULT_LANDING_PAGE } from "@/lib/marketingDefaults";

/**
 * Marketing Sanity fetches must run on the server.
 * Client-side route loaders otherwise call api.sanity.io from the browser;
 * without a matching Sanity CORS origin that fails and falls back to DE defaults.
 */
const previewInput = z.object({
  preview: z.boolean().optional(),
});

export const getLandingPage = createServerFn({ method: "GET" })
  .validator(previewInput)
  .handler(async ({ data }) => {
    const landing = await fetchLandingPage(Boolean(data.preview));
    return landing ?? DEFAULT_LANDING_PAGE;
  });

export const getAboutPage = createServerFn({ method: "GET" })
  .validator(previewInput)
  .handler(async ({ data }) => {
    const about = await fetchAboutPage(Boolean(data.preview));
    return about ?? DEFAULT_ABOUT_PAGE;
  });
